import { render, staticRenderFns } from "./PRIVATEMESSAGE.vue?vue&type=template&id=1ac513f6"
import script from "./PRIVATEMESSAGE.vue?vue&type=script&lang=js"
export * from "./PRIVATEMESSAGE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports